export const UPDATE_OBSERVACOES_TURMA = 'UPDATE_OBSERVACOES_TURMA'
export const ADD_OBSERVACOES_TURMA = 'ADD_OBSERVACOES_TURMA'
export const SET_OBSERVACOES_TURMA = 'SET_OBSERVACOES_TURMA'
export const REMOVE_OBSERVACOES_TURMA = 'REMOVE_OBSERVACOES_TURMA'
export const SET_OBSERVACAO_TURMA = 'SET_OBSERVACAO_TURMA'
export const SET_OBSERVACAO_TURMA_NULL = 'SET_OBSERVACAO_TURMA_NULL'